import { useCallback, useEffect, useState } from "react";
import { apiFetch, ApiError } from "./api";

// M6 — the "Cambios verificados" panel reads real `verifications` rows: one per
// re-crawl check (page renders no-JS, expected JSON-LD type present, direct-answer
// signal present), each with an ok flag + a timestamp. Written only by the server
// verify path (POST /api/recommendations/:id/verify).

export interface Verification {
  id: string;
  recommendation_id: string;
  site_id: string;
  check_name: string;
  ok: boolean;
  detail: string | null;
  created_at: string;
}

interface ListResp {
  ok: boolean;
  verifications: Verification[];
}

interface VerifsState {
  verifs: Verification[];
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

export function useVerifications(token: string, siteId: string | null): VerifsState {
  const [verifs, setVerifs] = useState<Verification[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!siteId) {
      setVerifs([]);
      setLoading(false);
      return;
    }
    try {
      const res = await apiFetch<ListResp>(`/api/sites/${siteId}/verifications`, token);
      setVerifs(res.verifications ?? []);
      setError(null);
    } catch (e) {
      setError(e instanceof ApiError ? e.code : "load_failed");
    } finally {
      setLoading(false);
    }
  }, [token, siteId]);

  useEffect(() => {
    setLoading(true);
    void refresh();
  }, [refresh]);

  return { verifs, loading, error, refresh };
}
